<template>
  <div class="jobs-next-button">
    <BravadoButtonV3 v-bind="$attrs" elevated v-on="$listeners">
      <slot />
      <ArrowRightIcon slot="append-icon" />
    </BravadoButtonV3>
  </div>
</template>

<script>
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import ArrowRightIcon from '@/components/partials/jobs/JobsCustomAction/images/arrow-right.vue.svg';

export default {
  name: 'JobsNextButton',
  components: {
    BravadoButtonV3,
    ArrowRightIcon,
  },
};
</script>
<style scoped lang="scss">
.jobs-next-button {
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
}
</style>
